import Image1 from '../assets/images/result/01.png';
import Image2 from '../assets/images/result/02.png';
import Image3 from '../assets/images/result/03.png';
import Image4 from '../assets/images/result/04.png';
import Image5 from '../assets/images/result/05.png';
import Image6 from '../assets/images/result/06.png';
import Image7 from '../assets/images/result/07.png';
import Image8 from '../assets/images/result/08.png';
import Image9 from '../assets/images/result/09.png';
import Image10 from '../assets/images/result/10.png';
import Image11 from '../assets/images/result/11.png';
import Image12 from '../assets/images/result/12.png';
import Image13 from '../assets/images/result/13.png';
import Image14 from '../assets/images/result/14.png';
import Image15 from '../assets/images/result/15.png';
import Image16 from '../assets/images/result/16.png';
import Image17 from '../assets/images/result/17.png';
import Image18 from '../assets/images/result/18.png';
import Image19 from '../assets/images/result/19.png';
import Image20 from '../assets/images/result/20.png';
import Image21 from '../assets/images/result/21.png';
import Image22 from '../assets/images/result/22.png';
import Image23 from '../assets/images/result/23.png';
import Image24 from '../assets/images/result/24.png';
import Image25 from '../assets/images/result/25.png';
import Image26 from '../assets/images/result/26.png';
import Image27 from '../assets/images/result/27.png';
import Image28 from '../assets/images/result/28.png';
import Image29 from '../assets/images/result/29.png';
import Image30 from '../assets/images/result/30.png';
import Image31 from '../assets/images/result/31.png';
import Image32 from '../assets/images/result/32.png';
import Image33 from '../assets/images/result/33.png';
import Image34 from '../assets/images/result/34.png';
import { Book, BookCopy, ChartNoAxesCombined, Goal, GraduationCap, Trophy, Zap, School } from 'lucide-react';

/* =========================
   MAIN RESULTS DATA
========================= */
export const resultsData = {
  year: 2025,

  /* -------- RESULT HIGHLIGHTS -------- */
  highlights: [
    {
      id: 1,
      title: 'JEE Main',
      total: '99%',
      description: 'Students above 99 %ile',
      icon: <Zap className="h-10 w-10 text-secondary m-auto" />
    },
    {
      id: 2,
      title: 'JEE Advanced',
      total: '65%',
      description: 'Qualified Students',
      icon: <Trophy className="h-10 w-10 text-warning m-auto" />
    },
    {
      id: 3,
      title: 'Board Result 2025',
      total: '97%',
      description: 'Highest Score',
      icon: <Book className="h-10 w-10 text-info m-auto" />
    },
    {
      id: 4,
      title: 'IIT / NIT / BITS',
      total: '72%',
      description: 'Selection Rate',
      icon: <Goal className="h-10 w-10 text-success m-auto" />
    }
  ],

  /* -------- TOP PERFORMERS (CARDS) -------- */
  // toppers: [
  //   {
  //     id: 1,
  //     name: 'Rishabh Jain',
  //     result: '99.92 %ile',
  //     exam: 'JEE Main 2025',
  //     image: Image1,
  //     selection: 'JEE Main'
  //   },
  //   {
  //     id: 2,
  //     name: 'Yuvraj Tak',
  //     result: '99.67 %ile',
  //     exam: 'JEE Main 2025',
  //     image: Image2,
  //     selection: 'JEE Main'
  //   },
  //   {
  //     id: 3,
  //     name: 'Rahul Maru',
  //     result: 'AIR 938',
  //     exam: 'JEE Advanced',
  //     image: Image3,
  //     selection: 'JEE Advanced'
  //   },
  //   {
  //     id: 4,
  //     name: 'Tanay Laddha',
  //     result: 'AIR 1041',
  //     exam: 'JEE Advanced',
  //     image: Image4,
  //     selection: 'JEE Advanced'
  //   }
  // ],

  topHighlights: [
    {
      name: 'Rishabh Jain',
      result: '99.92 %ile',
      exam: 'JEE Main 2025',
      image: Image1,
      priority: 1
    },
    {
      name: 'Yuvraj Tak',
      result: '99.67 %ile',
      exam: 'JEE Main 2025',
      image: Image2,
      priority: 2
    },
    {
      name: 'Rishabh Jain',
      result: '99.12 %ile',
      exam: 'JEE Main 2025',
      image: Image3,
      priority: 3
    },
    {
      name: 'Adhya Pareek',
      result: '97%',
      exam: 'Class 12 Board',
      remark: 'District Topper',
      image: Image15,
      priority: 4
    }
  ],

  /* -------- JEE MAIN RESULTS -------- */
  jeeMain: [
    { name: 'Rishabh Jain', score: '99.92 %ile', image: Image1 },
    { name: 'Yuvraj Tak', score: '99.67 %ile', image: Image2 },
    { name: 'Rishabh Jain', score: '99.12 %ile', image: Image3 },
    { name: 'Sazid Ali', score: '98.57 %ile', image: Image4 },
    { name: 'Sudarshan Jangid', score: '98.46 %ile', image: Image5 },
    { name: 'Ridhi Rathi', score: '98.38 %ile', image: Image6 }
  ],

  /* -------- JEE ADVANCED RESULTS -------- */
  jeeAdvanced: [
    { name: 'Rahul Maru', rank: 'AIR 938', image: Image7 },
    { name: 'Tanay Laddha', rank: 'AIR 1041', image: Image8 },
    { name: 'Rishabh Jain', rank: 'AIR 1667', image: Image9 },
    { name: 'Rishabh Jain', rank: 'AIR 4345', image: Image10 },
    { name: 'Sudarshan Jangid', rank: 'AIR 4778', image: Image11 },
    { name: 'Mahim Jain', rank: 'AIR 10050', image: Image12 },
    { name: 'Sazid Ali', rank: 'AIR 11025', image: Image13 },
    { name: 'Yuvraj Tak', rank: 'AIR 11523', image: Image14 }
  ],

  /* -------- BOARD RESULTS -------- */
  boardResults: {
    class12: [
      {
        name: 'Adhya Pareek',
        marks: '97%',
        remark: 'District Topper', image: Image15
      },
      { name: 'Rishabh Jain', marks: '92%', image: Image16 },
      { name: 'Yuvraj Tak', marks: '92%', image: Image17 },
      { name: 'Shivani Surana', marks: '91%', image: Image18 },
      { name: 'Sudarshan Jangid', marks: '90%', image: Image19 }
    ],

    class10: [
      { name: 'Lakshita Ranawat', marks: '93.5%', image: Image20 },
      { name: 'Tanish Balawat', marks: '92%', image: Image21 },
      { name: 'Puja Jhunjhunwala', marks: '92%', image: Image22 }
    ]
  },

  /* -------- IIT / NIT / BITS SELECTIONS -------- */
  selections: [
    { name: 'Rishabh Jain', college: 'IIT Bombay', image: Image23 },
    { name: 'Rahul Maru', college: 'IIT Bombay', image: Image24 },
    { name: 'Tanay Laddha', college: 'IIT Hyderabad', image: Image25 },
    { name: 'Mahim Jain', college: 'IIT Kharagpur', image: Image26 },
    { name: 'Sazid Ali', college: 'IIT Hyderabad', image: Image27 },
    { name: 'Yuvraj Tak', college: 'NIT Jaipur', image: Image28 },
    { name: 'Numan Rangrez', college: 'NIT Hamirpur', image: Image29 },
    { name: 'Shivam Napit', college: 'NIT Surat', image: Image30 },
    { name: 'Palak Jain', college: 'NIT Jaipur', image: Image31 },
    { name: 'Ayushi Agarwal', college: 'NIT Surat', image: Image32 },
    { name: 'Rishabh Jain', college: 'BITS Pilani', image: Image33 },
    { name: 'Mudit Goyal', college: 'BITS Pilani', image: Image34 }
  ],

  /* -------- RESULT GALLERY -------- */
  gallery: [
    { id: 1, image: Image1 },
    { id: 2, image: Image2 },
    { id: 3, image: Image3 },
    { id: 4, image: Image4 },
    { id: 5, image: Image5 },
    { id: 6, image: Image6 }
  ],

  /* -------- OVERALL STATISTICS -------- */
  statistics: [
    { label: 'Years of Excellence', value: '5+', icon: <GraduationCap className="h-12 w-12 text-success m-auto" /> },
    { label: 'IIT / NIT / BITS', value: '72%', icon: <School className="h-12 w-12 text-info m-auto" /> },
    { label: '99%ile Achievers', value: '99%', icon: <ChartNoAxesCombined className="h-12 w-12 text-secondary m-auto" /> },
    { label: 'Board 90%+', value: '90%', icon: <BookCopy className="h-12 w-12 text-warning m-auto" /> }
  ]
};

/* =========================
   YEAR-WISE PERFORMANCE
   (SAFE TREND DATA)
========================= */
export const yearWiseResults = [
  { year: '2023', jeeMain: 6, jeeAdvanced: 4, boards: 5 },
  { year: '2024', jeeMain: 8, jeeAdvanced: 6, boards: 7 },
  { year: '2025', jeeMain: 12, jeeAdvanced: 10, boards: 9 }
];
